const appleAuth = {
  isSupported: false,
  performRequest: async () => ({}),
  Operation: { LOGIN: 0, REFRESH: 1, LOGOUT: 2 },
  Scope: { EMAIL: 0, FULL_NAME: 1 },
};

module.exports = {
  appleAuth,
  default: appleAuth,
};
